var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row fabric-spacer items-center"},[_c('div',{staticClass:"col-auto non-selectable"},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")]),_c('div',{staticClass:"col"})])}
var staticRenderFns = []

export { render, staticRenderFns }